// REQUIRES
require('./bootstrap');

// JS
var northAmericanStates = {
  "AL": "Alabama",
  "AK": "Alaska",
  "AS": "American Samoa",
  "AZ": "Arizona",
  "AR": "Arkansas",
  "CA": "California",
  "CO": "Colorado",
  "CT": "Connecticut",
  "DE": "Delaware",
  "DC": "District Of Columbia",
  "FM": "Federated States Of Micronesia",
  "FL": "Florida",
  "GA": "Georgia",
  "GU": "Guam",
  "HI": "Hawaii",
  "ID": "Idaho",
  "IL": "Illinois",
  "IN": "Indiana",
  "IA": "Iowa",
  "KS": "Kansas",
  "KY": "Kentucky",
  "LA": "Louisiana",
  "ME": "Maine",
  "MH": "Marshall Islands",
  "MD": "Maryland",
  "MA": "Massachusetts",
  "MI": "Michigan",
  "MN": "Minnesota",
  "MS": "Mississippi",
  "MO": "Missouri",
  "MT": "Montana",
  "NE": "Nebraska",
  "NV": "Nevada",
  "NH": "New Hampshire",
  "NJ": "New Jersey",
  "NM": "New Mexico",
  "NY": "New York",
  "NC": "North Carolina",
  "ND": "North Dakota",
  "MP": "Northern Mariana Islands",
  "OH": "Ohio",
  "OK": "Oklahoma",
  "OR": "Oregon",
  "PW": "Palau",
  "PA": "Pennsylvania",
  "PR": "Puerto Rico",
  "RI": "Rhode Island",
  "SC": "South Carolina",
  "SD": "South Dakota",
  "TN": "Tennessee",
  "TX": "Texas",
  "UT": "Utah",
  "VT": "Vermont",
  "VI": "Virgin Islands",
  "VA": "Virginia",
  "WA": "Washington",
  "WV": "West Virginia",
  "WI": "Wisconsin",
  "WY": "Wyoming",
  "BC": "British Columbia",
  "ON": "Ontario",
  "NL": "Newfoundland and Labrador",
  "NS": "Nova Scotia",
  "PE": "Prince Edward Island",
  "NB": "New Brunswick",
  "QC": "Quebec",
  "MB": "Manitoba",
  "SK": "Saskatchewan",
  "AB": "Alberta",
  "NT": "Northwest Territories",
  "NU": "Nunavut",
  "YT": "Yukon Territory",
  "DIF": "Distrito Federal",
  "AGU": "Aguascalientes",
  "BCN": "Baja California",
  "BCS": "Baja California Sur",
  "CAM": "Campeche",
  "COA": "Coahuila",
  "COL": "Colima",
  "CHP": "Chiapas",
  "CHH": "Chihuahua",
  "DUR": "Durango",
  "GUA": "Guanajuato",
  "GRO": "Guerrero",
  "HID": "Hidalgo",
  "JAL": "Jalisco",
  "MEX": "México",
  "MIC": "Michoacán",
  "MOR": "Morelos",
  "NAY": "Nayarit",
  "NLE": "Nuevo León",
  "OAX": "Oaxaca",
  "PUE": "Puebla",
  "QUE": "Querétaro",
  "ROO": "Quintana Roo",
  "SLP": "San Luis Potosí",
  "SIN": "Sinaloa",
  "SON": "Sonora",
  "TAB": "Tabasco",
  "TAM": "Tamaulipas",
  "TLA": "Tlaxcala",
  "VER": "Veracruz",
  "YUC": "Yucatán",
  "ZAC": "Zacatecas"
};

(function() {
    var method;
    var noop = function () {};
    var methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeStamp', 'trace', 'warn'
    ];
    var length = methods.length;
    var console = (window.console = window.console || {});

    while (length--) {
        method = methods[length];

        // Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }
}());

$.fn.serializeObject = function() {
  var o = {};
  var a = this.serializeArray();
  $.each(a, function() {
    if (o[this.name] !== undefined) {
      if (!o[this.name].push) {
        o[this.name] = [o[this.name]];
      }
      o[this.name].push(this.value || '');
    } else {
      o[this.name] = this.value || '';
    }
  });
  return o;
};

Masonry.prototype._getMeasurement = function( measurement, size ) {
  var option = this.options[ measurement ];
  var elem;
  if ( !option ) {
    // default to 0
    this[ measurement ] = 0;
  } else if ( typeof option === 'function' ) {
    this[ measurement ] = option.call( this );
  } else {
    // use option as an element
    if ( typeof option === 'string' ) {
      elem = this.element.querySelector( option );
    } else if ( isElement( option ) ) {
      elem = option;
    }
    // use size of element, if element
    this[ measurement ] = elem ? getSize( elem )[ size ] : option;
  }
};

function parseURL(url) {

    var parser = document.createElement('a'),
        searchObject = {},
        queries, split, i;
    // Let the browser do the work
    parser.href = url;
    // Convert query string to object
    queries = parser.search.replace(/^\?/, '').split('&');
    for( i = 0; i < queries.length; i++ ) {
        split = queries[i].split('=');
        searchObject[split[0]] = split[1];
    }
    return {
        protocol: parser.protocol,
        host: parser.host,
        hostname: parser.hostname,
        port: parser.port,
        pathname: parser.pathname,
        search: parser.search,
        searchObject: searchObject,
        hash: parser.hash
    };

}

jQuery(document).ready(function($) {

  $('html').removeClass('no-js').addClass('js-loaded')

  //----------------------------------------------------------------------
  // Global Page Tracking
  //----------------------------------------------------------------------
  if ( $('body').hasClass('home') ) {
    var location = parseURL(window.location.href);
    if(parseInt(location.searchObject['gdpr_alumni_profile_registration']) === 1) {
      var trackingObj = {
          'site_events': {
            'alumni_profile_registration': 'true'
          },
        }
      _dl = Object.assign(trackingObj, _dl);
    }
  }

  $('.profile-inline-form').submit( function(e) {

    e.preventDefault();

    var thisForm       = $(this);
    var submitButton   = thisForm.find('input[type="submit"]');
    var formData       = thisForm.serializeObject();
    formData.id        = $('.id').val();
    formData.ContactId = $('.crm-data .ContactId').val();

    var formDataString = formData[ Object.keys( formData )[0] ];

    if ( thisForm.hasClass('profile-form-email') ) {

      var emailAddress1  = $('#EmailAddress1').val();
      var emailAddress2  = $('#EmailAddress2').val();

      if ( formData.EmailAddressPrimary ) {

        formData.EmailAddress1 = formData.EmailAddress;

        $('.my-profile-email-list').find('small').html('');
        $('.profile-form-email input[type=checkbox]').removeProp('checked');
        thisForm.find('input[type=checkbox]').prop('checked', true);
        formDataString = formData.EmailAddress;
        formDataString += ' <small>Primary</small>';

      } else {

        formData.EmailAddress1 = emailAddress1;
        formData.EmailAddress2 = emailAddress2;

        formDataString = formData.EmailAddress;

      }

    }

    if ( thisForm.hasClass('profile-form-phone') ) {

      var phone1;
      var phone1Type;

      var phone2;
      var phone2Type;

      if ( formData.PhoneType == 'Telephone1' ) {

        phone1 = $('.crm-data .TelePhone2').val();
        phone1Type = 'TelePhone2';

        phone2 = $('.crm-data .MobilePhone').val();
        phone2Type = 'MobilePhone';

      }

      if ( formData.PhoneType == 'TelePhone2' ) {

        phone1 = $('.crm-data .Telephone1').val();
        phone1Type = 'Telephone1';

        phone2 = $('.crm-data .MobilePhone').val();
        phone2Type = 'MobilePhone';

      }

      if ( formData.PhoneType == 'MobilePhone' ) {

        phone1 = $('.crm-data .Telephone1').val();
        phone1Type = 'Telephone1';

        phone2 = $('.crm-data .TelePhone2').val();
        phone2Type = 'TelePhone2';

      }

      if ( formData.PreferredPhoneNumber ) {

        if ( formData.Telephone1 ) {
          formData.PreferredPhoneNumber = 100000001;
        } else if ( formData.TelePhone2 ) {
          formData.PreferredPhoneNumber = 100000000;
        } else if ( formData.MobilePhone ) {
          formData.PreferredPhoneNumber = 100000002;
        }

        $('.my-profile-phone-list').find('small').html('');
        $('.profile-form-phone input[type=checkbox]').removeProp('checked');
        thisForm.find('input[type=checkbox]').prop('checked', true);
        formDataString += ' <small>Preferred</small>';

      } else {
        formData.PreferredPhoneNumber = $('.PreferredPhoneNumber').val();
      }

      if ( phone1 ) {
        formData[ phone1Type ] = phone1;
      }

      if ( phone2 ) {
        formData[ phone2Type ] = phone2;
      }

    }

    if ( thisForm.hasClass('profile-form-professional-organizations') ) {
      formDataString = formData.ProfessionalOrganizationName ? '<label class="my-profile-list-item-label">Name:</label>' + formData.ProfessionalOrganizationName : '';
      formDataString += formData.ProfessionalOrganizationName && formData.Role ? '<br/>' : '';
      formDataString += formData.Role ? '<label class="my-profile-list-item-label">Role:</label>' + formData.Role : '';
    }

    if ( thisForm.hasClass('profile-form-address') ) {

      var addressRecordType = '';

      switch( formData.OverwriteParentRecordsAddressName ) {
        case "Overwrite Address 1 (preferred mail to)":
            addressRecordType = 'Primary';
            break;
        case "Overwrite Address 2":
            addressRecordType = 'Secondary';
            break;
      }

      formDataString = '<small>' + formData.AddressTypeName + ' Address &ndash; ' + addressRecordType + '</small><br/>';
      formDataString += formData.Street1 + '<br />' + formData.Street2 + '<br/>';
      formDataString += formData.City + ', ' + formData.StateID + ' ' + formData.ZipPostalCode;

    }

    if ( thisForm.hasClass('profile-form-other-education') ) {
      formDataString = '<label class="my-profile-list-item-label">School Name: </label> ' + formData.Name + '<br/>';
      formDataString += '<label class="my-profile-list-item-label">Degree: </label> ' + formData.ProgramDescription + '<br/>';
      formDataString += '<label class="my-profile-list-item-label">Specialty: </label> ' + formData.OtherSpeciality + '<br/>';
      year = formData.RoleEndDate.split("/");
      year = typeof year[2] !== 'undefined' ? year[2].substring(0, 4) : year[0];
      formDataString += '<label class="my-profile-list-item-label">Year: </label> ' + year;
    }

    formData['PrimaryOrSecondary'] = 'null';

    if ( thisForm.find("input[name='OverwriteParentRecordsAddressName']:checked").attr('data-priority')) {

      switch(thisForm.find("input[name='OverwriteParentRecordsAddressName']:checked").attr('data-priority')) {
        case 'Primary':
          formData['PrimaryOrSecondary'] = 'P';
          break;
        case 'Secondary':
          formData['PrimaryOrSecondary'] = 'S';
          break;
      }

    }

    var ajaxData = {
      action    : thisForm.attr('action'),
      crm_nonce : localized_object.nonce,
      data      : formData
    };

    $.ajax({
      type       : "POST",
      url        : localized_object.ajax_url,
      data       : ajaxData,
      dataType   : "json",
      timeout    : 20000,
      beforeSend : function() {

          submitButton.prop("disabled", true);
          submitButton.prop("disabled", true);
          thisForm.css({'cursor': 'wait'});
          thisForm.find('input, a, select, label').css({'cursor': 'wait'});

          return validateAddressForm(thisForm);
      }
    })
    .done( function( response ) {

      if ( response && typeof response.error !== 'undefined' ) {
        // Do something on error
      } else {
        thisForm.parent().parent().find('.my-profile-list-item-current-values span').html( formDataString );
      }

      thisForm.closest('.my-profile-list-item').toggleClass('show-form');

    })
    .fail( function( request, status, err ) {

      console.log( 'REQUEST => ' + request );
      console.log( 'STATUS => ' + status );
      console.log( 'ERR => ' );
      console.log( err );

    }).always(function() {

      submitButton.prop("disabled", false);
      //   thisForm.closest('.my-profile-list-item').toggleClass('show-form');
      thisForm.css({'cursor': 'auto'});
      thisForm.find('input, a, select, label').css({'cursor': 'auto'});

    });

  });

  function validateAddressForm(form) {

    // If business address Company Name field is required
    if( form.find('.AddressTypeName option:selected').text() == 'Business') {

      if( form.find('.settings-address-company-name input').val().length < 1 ) {
        form.find('.settings-address-company-name').addClass('not-valid');
        return false;
      } else {
        $('.settings-address-company-name').removeClass('not-valid');
        return true;
      }

    }

    // If seasonal address Start Month and End Month are required
    if( form.find('.AddressTypeName option:selected').text() == 'Seasonal') {

      var $startMonth = form.find('.settings-address-start-month');
      var $endMonth = form.find('.settings-address-end-month');
      var fields = [$startMonth, $endMonth];
      var validFields = $.extend(true, [], fields);

      for( var i=0; i<fields.length; i++ ) {

        var $field = fields[i];

        if( $field.find('select').val().length < 1 ) {
          $field.addClass('not-valid');
        } else {
          $field.removeClass('not-valid');
          validFields.splice(0, 1);
        }

      }

      if (validFields.length > 0) {
        return false;
      } else {
        return true;
      }

    }

  }

// Update Existing Email, Phone, Address
$('.profile-form').on('submit', function (e) {

    e.preventDefault();
    
    let thisForm = $(this);
    let alert = thisForm.parent().find("#alert");
    let submitButton = thisForm.find('input[type="submit"]');
    let formData = thisForm.serializeObject();
    
    formData.id = $('.id').val();
    formData.ContactId = $('.crm-data .ContactId').val();
    
    let ajaxData = {
        action: thisForm.attr('action'),
        crm_nonce: localized_object.nonce,
        data: formData
    };

    console.log(ajaxData);

    $.ajax({
        type: "POST",
        url: localized_object.ajax_url,
        data: ajaxData,
        dataType: "json",
        timeout: 20000,
        beforeSend: function () {
            submitButton.prop("disabled", true);
            submitButton.prop("disabled", true);
            thisForm.css({ 'cursor': 'wait' });
            thisForm.find('input, a, select, label').css({ 'cursor': 'wait' });
            alert.text('');
            alert.removeClass('alert-danger');
            alert.removeClass('alert-success');
            alert.addClass('hidden');
        }
    })
    .done(function (response) {

        console.log(response);

        if (thisForm.hasClass('profile-form-password')) {

            window.location.replace("/login/");

        } else if (response.error || (typeof response.data.updateContactData !== "undefined" && response.data.updateContactData.indexOf('error') > 0)) {
          // show error text

            let errorMessage = response.error ? response.error : 'Something went wrong';
            
            alert.text(errorMessage);
            alert.addClass('alert-danger');
            alert.removeClass('hidden');

        } else if (response.data.updateContactData || response.data.addPhone) {

            alert.text('data successfully added.');
            alert.addClass('alert-success');
            alert.removeClass('hidden');

        } else {
            // server error or other error (Please check all fields and try again.)

            alert.text("Something went wrong. Please check all fields and try again.");
            alert.addClass('alert-danger');
            alert.removeClass('hidden');
        }

    })
    .fail(function (request, status, err) {

        console.log('REQUEST => '); console.log(request);
        console.log('STATUS => ' + status);
        console.log('ERR => ');
        console.log(err);

    })
    .always(function () {

        submitButton.prop("disabled", false);
        thisForm.css({ 'cursor': 'auto' });
        thisForm.find('input, a, select, label').css({ 'cursor': 'auto' });

    });
});

  function createNewListItem( type, value, action ) {

    var output = '';

    output += '<li class="my-profile-list-item"><span class="my-profile-list-item-current-values"><span>'+value+'</span></span></li>';
    // output += '<div class="my-profile-list-item-form"><form action="'+action+'" name="" class="profile-inline-form"><div class="input-container"><div class="input-row"><div class="input-column input-column-12"><input type="text" value="'+value+'" name="FieldOfPracticeId" id="FieldOfPracticeId2"></div>';
    // output += '<div class="input-column input-column-6"><input type="submit" name="" class="my-profile-list-item-form-update button button-blue" value="Update"></div><div class="input-column input-column-6"><a href="#" class="my-profile-list-item-form-cancel button button-gray">Cancel</a></div><div class="input-column input-column-12"><a href="#" class="my-profile-delete-record">Delete</a></div></div></div></form></div></li>';

    return output;

  }

  $('.add-profile-info').on('click', function(e) {

    e.preventDefault();
    $(this).parent().next().toggleClass('is-visible');

  });

  $('.AddressTypeName').on('change', function() {

    if ( $(this).val() == 'Business' ) {
      $(this).closest('form').find('.settings-address-company-name').show();
      $(this).closest('form').find('.settings-address-start-month').hide();
      $(this).closest('form').find('.settings-address-end-month').hide();
    } else if ( $(this).val() == 'Seasonal' ) {
      $(this).closest('form').find('.settings-address-company-name').hide();
      $(this).closest('form').find('.settings-address-start-month').show();
      $(this).closest('form').find('.settings-address-end-month').show();
    } else {
      $(this).closest('form').find('.settings-address-company-name').hide();
      $(this).closest('form').find('.settings-address-start-month').hide();
      $(this).closest('form').find('.settings-address-end-month').hide();
    }

  });

  $('.profile-form-toggle').on('click', function(e) {

    e.preventDefault();
    $(this).closest('.my-profile-form').toggleClass('is-visible');

  });

  $('.my-profile-section, .settings-section').on('click', '.edit-profile-list-item', function(e) {

    e.preventDefault();
    $(this).parent().parent().toggleClass('show-form');

  });

  $('.my-profile-section, .settings-section').on('click', '.my-profile-list-item-form-cancel', function(e) {

    e.preventDefault();
    $(this).closest('.my-profile-list-item').removeClass('show-form');

  });

$('.mentor-delete-residency').on('click', function(e) {

    e.preventDefault();

    var thisForm                                    = $(this);
    var formData                                    = {"post": $(this).attr('data-post')};
    formData.id                                     = $('.id').val();

    var ajaxData = {
        action    : 'remove_mentorship_residency',
        crm_nonce : localized_object.nonce,
        data      : formData
    };

    $.ajax({
        type       : "POST",
        url        : localized_object.ajax_url,
        data       : ajaxData,
        dataType   : "json",
        timeout    : 20000,
        beforeSend : function() {
            //   $('.privacy-radio-input').prop("disabled", true);
            }
        })
        .done( function( response ) {
            location.reload();
        })
        .fail( function( request, status, err ) {
            console.log( 'ERR => ' );
            console.log( err );
            console.log(request);
            console.log(status);
        }).always(function() {
            // $('.privacy-radio-input').prop("disabled", false);
        });
});

$('#mayo_alumni_mentor_enrollment_remove').on('click', function(e) {

    e.preventDefault();

    var thisForm                                    = $(this);
    var formData                                    = {};
    formData.id                                     = $('.id').val();

    $('#mentorship-enrollment-form :input').each(function(index) {
        formData[this.name] = $(this).val();
    });

    var ajaxData = {
        action    : 'remove_mentorship_status',
        crm_nonce : localized_object.nonce,
        data      : formData
    };

    $.ajax({
        type       : "POST",
        url        : localized_object.ajax_url,
        data       : ajaxData,
        dataType   : "json",
        timeout    : 20000,
        beforeSend : function() {
          $('#mentorship-enrollment-form').css({'opacity': 0.5});
          $('.input-row').find('input').prop('disabled', true);
          $('.select-dropdown').find('select').prop('disabled', true);
          $('textarea').prop('disabled', true);
            }
        })
        .done( function( response ) {

            var url = window.location.href.split(/[?#]/)[0];
            window.location.href = url + '?status=removed';
        })
        .fail( function( request, status, err ) {
            console.log( 'REQUEST => ' + request );
            console.log( 'STATUS => ' + status );
            console.log( 'ERR => ' );
            console.log( err );

            $('#mentorship-enrollment-form').css({'opacity': 1});
            $('.input-row').find('input').prop('disabled', false);
            $('.select-dropdown').find('select').prop('disabled', false);
            $('textarea').prop('disabled', true);

        }).always(function() {
            // $('.privacy-radio-input').prop("disabled", false);
        });

});

$('#mentorship-enrollment-form').on('submit', function(e){
    e.preventDefault();

    var thisForm                                   = $(this);
    var formData                                    = thisForm.serializeObject();
    formData['mayo_alumni_mentor_enrollment']       = true;
    formData.id                                     = $('.id').val();

    // validate
    var errors = [];
    $(this).find('.required').each( function(){
        if( $(this).val().length < 1 ) {
            // show error
            errors.push( $(this) );
            $(this).siblings('.error').addClass('visible');
            $(this).parent().siblings('.error').addClass('visible');
        } else {
            // hide error
            $(this).siblings('.error').removeClass('visible');
            $(this).parent().siblings('.error').removeClass('visible')
        }
    });

    if(errors.length > 0) {
        return false;
    }

    var residencyData;
    formData.residencies = [];

    // TODO: move and format template into script tag
    // exclude template from data
    $('#residency-input-template :input').each(function(index){
        delete formData[this.name];
    });


    $('.residency-input').each(function(index){

        var residency = {};

        $(this).find(':input').each(function(){
            residency[this.name] = $(this).val();
            delete formData[this.name];
        })

        formData.residencies.push(residency);
    });

    var ajaxData = {
        action    : 'update_mentorship_status',
        crm_nonce : localized_object.nonce,
        data      : formData
    };

    $.ajax({
        type       : "POST",
        url        : localized_object.ajax_url,
        data       : ajaxData,
        dataType   : "json",
        timeout    : 20000,
        beforeSend : function() {
            // show loader
            $('#mentorship-enrollment-form').css({'opacity': 0.5});
            $('.input-row').find('input').prop('disabled', true);
            $('.select-dropdown').find('select').prop('disabled', true);
            $('textarea').prop('disabled', true);
            }
        })
        .done( function( response ) {

            var url = window.location.href.split(/[?#]/)[0];
            window.location.href = url + '?status=signed-up';
        })
        .fail( function( request, status, err ) {
            console.log( 'REQUEST => ' + request );
            console.log( 'STATUS => ' + status );
            console.log( 'ERR => ' );
            console.log( err );

            $('#mentorship-enrollment-form').css({'opacity': 1});
            $('.input-row').find('input').prop('disabled', false);
            $('.select-dropdown').find('select').prop('disabled', false);
            $('textarea').prop('disabled', false);

        }).always(function() {
            // $('.privacy-radio-input').prop("disabled", false);
    });

});

  $('.privacy-radio-input').on('change', function (e) {

    e.preventDefault();

    var thisInput = $(this);
    var thisInputVal = (thisInput.attr('type') === 'radio') ? ($(this).is(':checked')) ? thisInput.attr('data-privacy-val') : 2 : thisInput.val();

    var formData = {};
    formData.mayo_alumni_profile_privacy = thisInputVal;
    formData.id = $('.id').val();
    formData.ContactId = $('.crm-data .ContactId').val();

    if (thisInputVal == 3) {
      $('#mayo_alumni_profile_privacy_1').prop('checked', false);
      $('.js-privacy-mccn-checkbox').prop('checked', false);
      formData.mayo_alumni_mccn_privacy = false;
    }

    var ajaxData = {
      action: 'put_crm_alumni_privacy',
      crm_nonce: localized_object.nonce,
      data: formData,
    };

    $.ajax({
      type: "POST",
      url: localized_object.ajax_url,
      data: ajaxData,
      dataType: "json",
      timeout: 20000,
      beforeSend: function () {
        $('input').prop("disabled", true);
      }
    })
    .done(function (response) {

        if (thisInputVal == 3) {
          $('#mayo_alumni_profile_privacy_1').parent().parent().addClass('blocked');
        } else {
          $('#mayo_alumni_profile_privacy_1').parent().parent().removeClass('blocked');
        }

    })
    .fail(function (request, status, err) {

        console.log('REQUEST => ' + request);
        console.log('STATUS => ' + status);
        console.log('ERR => ');
        console.log(err);

    }).always(function (data) {
        $('input').prop('disabled', false);
    });

  });
  
  $('.privacy-checkbox-input').on('change', function (e) {

    e.preventDefault();

    let formData = {
        databaseField: $(this).attr('id'),
        dataVal:       $(this).is(':checked'),
        id:            $('.id').val(),
        ContactId:     $('.crm-data .ContactId').val(),
        crmField:      $(this).attr('name'),
    }

    let ajaxData = {
        action: 'put_crm_alumni_privacy',
        crm_nonce: localized_object.nonce,
        data: formData,
    };

    $.ajax({
        type: "POST",
        url: localized_object.ajax_url,
        data: ajaxData,
        dataType: "json",
        timeout: 20000,
        beforeSend: function () {
          $('input').prop("disabled", true);
        }
    })
    .done(function (response) {

        $('input').prop("disabled", false);

    })
    .fail(function (request, status, err) {

        console.log('REQUEST => ' + request);
        console.log('STATUS => ' + status);
        console.log('ERR => ');
        console.log(err);

    }).always(function (data) {
        $('input').prop('disabled', false);
    });

  });

  // Add Other Education, Fields of Practice, and Professional Organizations
  $('.my-profile-add-list-form').on('submit', function (e) {

      e.preventDefault();
    
      let thisForm = $(this);
      let submitButton = thisForm.find('input[type="submit"]');
      let formData = thisForm.serializeObject();
    
      formData.id = $('.id').val();
      formData.ContactId = $('.crm-data .ContactId').val();
    
      let ajaxData = {
          action: thisForm.attr('action'),
          crm_nonce: localized_object.nonce,
          data: formData
      };
    
      myProfileAddListFormAjax( thisForm, submitButton, formData, ajaxData, true );
    
  });
  
  function myProfileAddListFormAjax( thisForm, submitButton, formData, ajaxData, reloadPage ) {
      $.ajax({
          type: "POST",
          url: localized_object.ajax_url,
          data: ajaxData,
          dataType: "json",
          timeout: 20000,
          beforeSend: function () {
              
              submitButton.prop("disabled", true);
              submitButton.prop("disabled", true);
              thisForm.css({ 'cursor': 'wait' });
              thisForm.find('input, a, select, label').css({ 'cursor': 'wait' });
              
          }
      })
      .done(function (response) {

          if(reloadPage) {
              window.location.reload(true);
          }

      })
      .fail(function (request, status, err) {

          console.log('REQUEST => '); console.log(request);
          console.log('STATUS => ' + status);
          console.log('ERR => ');
          console.log(err);

      })
      .always(function () {

          submitButton.prop("disabled", false);
          thisForm.css({ 'cursor': 'auto' });
          thisForm.find('input, a, select, label').css({ 'cursor': 'auto' });

      });
  }
  
  // Update Other Education, Fields of Practice, and Professional Organizations
  $('.my-profile-section, .settings-section').on('click', '.my-profile-delete-list-item', function (e) {
      
    e.preventDefault();

    let formData = {};
    let dataAction = '';

    formData.FieldOfPracticeId = $(this).attr('data-id');
    
    dataAction = $(this).attr('data-action');

    let ajaxData = {
        action: dataAction,
        crm_nonce: localized_object.nonce,
        data: formData
    };

    myProfileDeleteListItem( formData, dataAction, ajaxData );
    
  });
  
  function myProfileDeleteListItem( formData, dataAction, ajaxData ) {
      
      $.ajax({
          type: "POST",
          url: localized_object.ajax_url,
          data: ajaxData,
          dataType: "json",
          timeout: 20000,
          beforeSend: function () {
              
              $('input').prop("disabled", true);
              
          }
      })
      .done(function (response) {
          
          window.location.reload(true);
          
      })
      .fail(function (request, status, err) {
          
          console.log('REQUEST => ', request);
          console.log('STATUS => ' + status);
          console.log('ERR => ');
          
      }).always(function () {
          
          $('input').prop("disabled", false);
          
      });
  }
  
  // Update Other Education, Fields of Practice, and Professional Organizations
  $('.profile-form-add-fields-of-practice').on('submit', function (e) {

      e.preventDefault();
    
      let thisForm = $(this);
      let submitButton = thisForm.find('input[type="submit"]');
      let formData = thisForm.serializeObject();
      
      formData.ContactId = $('.crm-data .ContactId').val();
    
      let ajaxData = {
          action: thisForm.attr('action'),
          crm_nonce: localized_object.nonce,
          data: formData
      };
    
      myProfileAddListFormAjax(thisForm, submitButton, formData, ajaxData, false);
      
      // click the delete link
      thisForm.find('.my-profile-delete-list-item').click();
      
  });

  $('.my-profile-section, .settings-section').on('click', '.my-profile-delete-record', function(e) {

    e.preventDefault();

    if ( !$(this).data('keys') ) return;

    var thisSection    = $(this).closest('.show-form');
    var thisForm       = $(this).closest('form');
    var formData       = {};
    var action         = $(this).data('action') ? $(this).data('action') : 'delete_profile_meta';
    formData.keys      = $(this).data('keys') ? $(this).data('keys').split(',') : '';
    formData.values    = $(this).data('values') ? $(this).data('values').split(',') : '';
    formData.id        = $('.id').val();
    formData.ContactId = $('.crm-data .ContactId').val();

    $.each( formData.keys, function(index, value) {

      formData[ value ] = Array.isArray( formData.values ) ? formData.values[ index ] : '';

    });

    var ajaxData = {
      action    : action,
      crm_nonce : localized_object.nonce,
      data      : formData
    };

    $.ajax({
      type       : "POST",
      url        : localized_object.ajax_url,
      data       : ajaxData,
      dataType   : "json",
      timeout    : 20000,
      beforeSend : function() {
        thisForm.find('input').prop("disabled", true);
      }
    })
    .done( function( response ) {

      if ( response ) {
        if ( formData.keys[0] == 'mayo_alumni_photo' ) {
          $('.update-profile-pic').css('background-image', 'url(/wp-content/themes/mayo-health-sciences-alumni/assets/img/user-default.gif)').find('img').remove();
        }
      }

    })
    .fail( function( request, status, err ) {

      console.log( 'REQUEST => ' + request );
      console.log( 'STATUS => ' + status );
      console.log( 'ERR => ' );
      console.log( err );

    }).always(function() {

      thisForm.find('input').prop("disabled", false);

      if ( formData.keys[0] == 'mayo_alumni_photo' ) {
        thisSection.toggleClass('show-form');
      } else {
        thisSection.remove();
      }

    });

  });

  $('.update-profile-pic').on('click', function(e) {
    e.preventDefault();
    $(this).parent().toggleClass('show-form');
  });

  $('.profile-form-photo .my-profile-list-item-form-cancel').on('click', function(e) {
    e.preventDefault();
    $('.my-profile-personal-photo').toggleClass('show-form');
  });

  $('.my-profile-allow-contact').on('change', function(e) {

    e.preventDefault();

    var thisInput                                 = $(this);
    var thisInputVal                              = $(this).is(':checked') ? thisInput.val() : 'No';
    var formData                                  = {};
    formData['mayo_alumni_profile_allow_contact'] = thisInputVal;
    formData.id                                   = $('.id').val();
    formData.update                               = $('.my-profile-allow-contact-update').val();

    var ajaxData = {
      action    : 'update_profile',
      crm_nonce : localized_object.nonce,
      data      : formData
    };

    $.ajax({
      type       : "POST",
      url        : localized_object.ajax_url,
      data       : ajaxData,
      dataType   : "json",
      timeout    : 20000,
      beforeSend : function() {
        $('.my-profile-allow-contact').prop("disabled", true);
      }
    })
    .done( function( response ) {
      if ( response ) {
        $('.my-profile-allow-contact-update').val( thisInputVal );
      }

    })
    .fail( function( request, status, err ) {

      console.log( 'REQUEST => ' + request );
      console.log( 'STATUS => ' + status );
      console.log( 'ERR => ' );
      console.log( err );

    }).always(function() {

      $('.my-profile-allow-contact').prop("disabled", false);

    });

  });

  if ( $('.quanity-input').length > 0) {

    var quanityInput = $('.qty');

    $('.decrease-quanity').on('click', function( event ) {
      event.preventDefault();
      var curVal = parseInt( quanityInput.val() );
      var newVal = curVal > 1 ? curVal - 1 : 1;
      quanityInput.val( newVal );
    });

    $('.increase-quanity').on('click', function( event ) {
      event.preventDefault();
      var curVal = parseInt( quanityInput.val() );
      var newVal = curVal + 1;
      quanityInput.val( newVal );
    });

  }

  if ( $("#cat").length > 0 ) {
    $("#cat").on('change', function() {
      var catID = $(this).val() > 0 ? "/?cat=" + $(this).val() : '/news/';
      window.location.href = localized_object.base_url + catID;
    });
  }

  if ( $('.article-slideshow').length > 0 ) {

    $('.article-slideshow-image').on('click', function() {

      var slideID = $(this).data('slide-id');
      var parent = $(this).parent();
      var nextSlide = $(this).next('.article-slideshow-image').length > 0 ? $(this).next('.article-slideshow-image') : parent.find('.article-slideshow-image:first-child');
      var nextSlideID = nextSlide.data('slide-id');

      nextSlide.addClass('active');
      $(this).removeClass('active');

      $( '#article-slide-paginator-' + nextSlideID ).addClass('active');
      $( '#article-slide-paginator-' + slideID ).removeClass('active');

    });

  }

  if ( $('body').hasClass('page-settings') ) {

    $( ".autocomplete" ).autocomplete({
      source: window.states,
      change: function (event, ui) {

        var element = event.currentTarget.id;

        if (ui.item == null || ui.item == undefined) {

          var txtSearchProNum = $( "#" + element );
          txtSearchProNum.val("");

        }

      }

    });

  }

  if ( $('#password-reveal').length > 0 ) {

    var new_input = '';

    $('#password-reveal').on('click', function( event ) {
      event.preventDefault();

      var input      = $(this).prev();
      var input_type = input.attr('type');
      var input_val  = input.val();

      if ( input_type == 'text' ) {

        new_input = '<input type="password" value="'+input_val+'" name="password" id="password" class="input-text" />';
        $(this).text('Reveal');

      } else {

        new_input = '<input type="text" value="'+input_val+'" name="password" id="password" class="input-text" />';
        $(this).text('Hide');

      }

      input.remove();
      $(this).before( $(new_input) );

    });

  }

  $('[data-toggle="tooltip"]').tooltip({
    'html':true,
    'animation':false,
    'trigger': 'click hover'
  }).on('click', function(event) {
    event.preventDefault();
  });

  $( document ).on( 'found_variation', 'form.variations_form', function( event, variation ) {

    var variation_description = variation.variation_description ? variation.variation_description : "";

    if ( $('.single_variation_description').length > 0 && variation.variation_description ) {
      $('.single_variation_description').html('<h4>Product Description:</h4><p>' + variation_description + '</p>');
    } else if ( variation.variation_description ) {
      $('.variations_button_wrap').after( '<div class="single_variation_description"><h4>Product Description:</h4><p>'+ variation.variation_description +'</p></div>' );
    } else {
      $('.single_variation_description').remove();
    }

  });

  $( 'form.variations_form .variations select').trigger('change');

    // Email character filtering
    function initEmailCharacterFiltering() {
        // Define valid email characters regex (letters, numbers, @, ., -, _, +)
        var validEmailChars = /[^a-zA-Z0-9@._+-]/g;

        // Target all email input fields
        var emailSelectors = [
            'input[type="email"]',
            'input[name="email"]',
            'input[name="email_confirm"]',
            'input[name="email-confirm"]',
            'input[name="user_login"]',
            'input[name*="email"]',
            'input[id*="email"]',
            'input[placeholder*="Email"]',
            'input[placeholder*="email"]'
        ].join(', ');

        $(document).on('input paste keyup', emailSelectors, function(e) {
            var $input = $(this);
            var cursorPosition = this.selectionStart;
            var originalValue = $input.val();
            var filteredValue = originalValue.replace(validEmailChars, '');

            // Only update if value changed (to avoid infinite loops)
            if (originalValue !== filteredValue) {
                $input.val(filteredValue);

                // Restore cursor position, adjusting for removed characters
                var removedChars = originalValue.length - filteredValue.length;
                var newCursorPosition = Math.max(0, cursorPosition - removedChars);

                // Set cursor position back
                if (this.setSelectionRange) {
                    this.setSelectionRange(newCursorPosition, newCursorPosition);
                }
            }
        });

        // Handle paste events specifically to clean pasted content
        $(document).on('paste', emailSelectors, function(e) {
            var $input = $(this);

            // Use setTimeout to allow paste to complete first
            setTimeout(function() {
                var originalValue = $input.val();
                var filteredValue = originalValue.replace(validEmailChars, '');

                if (originalValue !== filteredValue) {
                    $input.val(filteredValue);
                }
            }, 10);
        });
    }

    // Initialize email character filtering
    initEmailCharacterFiltering();
});

var WooCommerce = {

  init: function() {

    WooCommerce.eventListeners();

  },

  eventListeners: function() {

  }

};

$(function() {
  WooCommerce.init();
});

var Overlay = {

  init: function() {

    if ( $('body').hasClass('overlay-active') ) {

      Overlay.setSize();
      Overlay.eventListeners();

    }

  },

  eventListeners: function() {

    $( window ).resize(function() {
      Overlay.setSize();
    });

    $('.overlay-content-close, .overlay-background').on('click', function( event ) {
      event.preventDefault();
      Overlay.close();
    });

  },

  close : function() {
    $('body').removeClass('overlay-active');
    $('.overlay').remove();
  },

  setSize : function() {

    var el        = $('.overlay-content');
    var elHeight  = el.outerHeight();
    var winHeight = $( window ).height();

    if ( elHeight >= winHeight ) {
      var newHeight = winHeight / 10;
      el.css({
        'height' : ( newHeight * 8 ) + 'px',
        'top' : ( ( winHeight / newHeight ) ) + '%'
      });
    } else {
      var diff = Math.round( ( ( ( winHeight - elHeight ) / 2 ) / winHeight ) * 100 - 1 );
      el.css({
        'height' : 'auto',
        'top' : diff + '%'
      });
    }

  }

};

$(function() {
  Overlay.init();
});

var App = {

  init: function() {

    App.eventListeners();

  },

  eventListeners: function() {

  }

};

$(function() {
  App.init();
});

var ProcessFormData = {

  formDataString: function( form ) {

    var output = '';

    switch( form ) {
      case "profile-form-phone":
          output = '';
          break;
      case "profile-form-phone":
          output = '';
          break;
      default:
          output = '';
    }

    return output;

  }

};

var Helpers = {

  isMobile: function() {
    var check = false;
    (function(a){
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) {
        check = true;
      }
    })(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  },

  isValidName: function( name ) {
    return name.search( /^[a-zA-Z][a-zA-Z\-'\s]{0,60}$/ ) != -1 ? true : false;
  },

  isValidEmail: function( email ) {
    return email.search( /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ ) != -1 ? true : false;
  },

  isValidPhone: function( phone ) {
    return phone.search( /(\W|^)[(]{0,1}\d{3}[)]{0,1}[\s-]{0,1}\d{3}[\s-]{0,1}\d{4}(\W|$)/ ) != -1 ? true : false;
  },

  inputExists: function( value ) {
    return value != '' ? true : false;
  }

};


var Mentorship = (function() {

  var residencyIndex = 0;

    var init = function init() {
        _addListeners();

        // if no residecies exist, inset residency preview template
        if($('.mentorship-preview ul').children().length < 1) {
            $('.add-mentorship-residency').trigger('click');
        }

        $('.mentor-profile').trigger('input');

    }

    var _addListeners = function _addListeners() {

      // to move preview element down with scroll
      $(window).scroll(function(e){
        var $el = $('.mentorship-preview');
        var isPositionFixed = ($el.css('position') == 'fixed');

        if ($(this).scrollTop() > $el.parent('.row').offset().top && !isPositionFixed && !_previewAboveForm()) {
          $el.removeClass('fixed-bottom');
          $el.addClass('fixed');
        }

        if( _previewAboveForm() ) {
          $el.addClass('fixed-bottom');
          $el.removeClass('fixed');
        } else {
          $el.removeClass('fixed-bottom');
        }

        if ($(this).scrollTop() < $el.parent('.row').offset().top && isPositionFixed || _previewAboveForm() ) {
          $el.removeClass('fixed');
          $el.removeClass('fixed-bottom');
        }

      });

        $('.page-mentorship').on('input', '.mentor-profile', _onMentorChange);
        $('.page-mentorship').on('change keyup keydown', '#Speciality', _onMentorChange);
        $('body').on('mouseup', '.ui-autocomplete li', _onMentorChange);


        $('.add-mentorship-residency').on('click', _onAddMentorshipClick);
        $('#mentorship-enrollment-form').on('click', '.button-residency-cancel', _onResidencyCancelClick);
    }

    var _previewAboveForm = function _previewAboveForm() {

      var $el = $('.mentorship-preview');

      if( ($el.offset().top + $el.outerHeight() + 20) > ($el.parent('.row').offset().top + $el.parent('.row').outerHeight()) && $el.offset().top > $el.parent('.row').offset().top ) {
        return true;
      } else {
        return false;
      }

    }

    //----------------------------------------------------------------------
    // Form Event Handlers
    //----------------------------------------------------------------------
    var _onMentorChange = function _onMentorEmailChange(event) {

        // If autocomplete use #Speciality data-attr
        var $previewField = ($(this).hasClass('mentor-profile')) ? $('#' + $(this).attr('data-preview')) : $('#' + $('#Speciality').attr('data-preview') );

        var text = ($(this).hasClass('mentor-profile')) ? $(this).val() : $(this).text();
        $previewField.text( text );
    }

    var _onAddMentorshipClick = function _onAddMentorshipClick(event) {

        event.preventDefault();

        var $residency = $('#residency-input-template').clone().removeAttr('id').addClass('residency-input');

        // increment data-preview attr to allow for multiple residency previews
        $residency.find(':input').each(function(){
            var attr = $(this).attr('data-preview') + residencyIndex;
            $(this).attr('data-preview', attr);
        });

        $residency.insertBefore($(this).parent());
        $residency.addClass('addResidencyForm' + residencyIndex);

        if( $('.mentorship-preview ul').children().length > 0 ) {
            var $cancelBtn = $residency.find('.button-residency-cancel');
            $cancelBtn.attr('data-residency', residencyIndex);
            $cancelBtn.addClass('active');
        }

        // add preview template
        // update data-preview index
        $residencyPreview = $('#residency-preview-template').clone().removeAttr('id');

        $residencyPreview.find('.field').each(function(index) {
            var id = $(this).attr('id') + residencyIndex;
            $(this).attr('id', id);
        });
        $residencyPreview.appendTo('.mentorship-preview ul');
        $residencyPreview.addClass('addResidencyForm' + residencyIndex);


        $( ".autocomplete" ).autocomplete({
          source: window.specialities,
          change: function (event, ui) {
            var element = event.currentTarget.id;
            if (ui.item == null || ui.item == undefined) {
              var txtSearchProNum = $( "#" + element );
              txtSearchProNum.val("");
            }
          }
        });

        residencyIndex++;
    }

    var _onResidencyCancelClick = function _onResidencyCancelClick(event) {
        event.preventDefault();

        // remove from form and preview
        var id = $(this).attr('data-residency');

        $('.mentorship-preview .addResidencyForm' + id).remove();
        $(this).closest('.residency-input').remove();
    }

    //----------------------------------------------------------------------
    // Expose
    //----------------------------------------------------------------------
    return {
        init: init
    }

})();


var InternationalProgram = {

    // Selectors
    $schedule: $('.section-schedule'),
    $btnExtendedSchedule: $('.btn-extended-schedule'),
    $btnsSchedule: $('.section-schedule .button'),
    $btnJumpMenu: $('.jump-menu a'),
    $btnBackToTop: $('.back-to-top'),

    // classes
    classExpanded: "expanded",
    classHidden: "hidden",

    btnCollapsedText: "Show All",
    btnCollapsedTextCnt: " (* Events)",
    btnExpandedText:"Show Less",

    init: function init() {
        // all .schedule-item elements come from WP with .hidden,
        // remove .hidden from number of events to be shown (data-num-default-events)
        $('.section-schedule .day').each(function() {
            $(this).find('.schedule-item')
            .slice(0, InternationalProgram.$schedule.attr('data-num-default-events'))
            .removeClass(InternationalProgram.classHidden);
        });

        // InternationalProgram.updateConferenceExtras();
        InternationalProgram.updateSchedule();
        InternationalProgram.addListeners();
    },

    // count number of .schedule-items in parent .day
    // update data-num-events and btn text
    updateSchedule: function updateSchedule() {
        for(var i=0; i<InternationalProgram.$btnsSchedule.length; i++){

            var $this = $(InternationalProgram.$btnsSchedule[i]);
            var numEvents = $this.parents('.day').find('.schedule-item').length;
            var cntText = InternationalProgram.btnCollapsedTextCnt.replace('*', numEvents);

            $this.attr('data-num-events', numEvents);
            $this.text(InternationalProgram.btnCollapsedText + cntText);
        }
    },

    addListeners: function addListeners() {
        InternationalProgram.$btnExtendedSchedule.on('click', InternationalProgram.onShowExtendedSchdule);
        InternationalProgram.$btnsSchedule.on('click', InternationalProgram.onScheduleShowCollapse);
        InternationalProgram.$btnJumpMenu.on('click', InternationalProgram.onAnchorLinkClick);
        InternationalProgram.$btnBackToTop.on('click', InternationalProgram.onBackToTopClick);
        $(window).resize(InternationalProgram.onResize);
    },

    //----------------------------------------------------------------------
    // Touch / Mouse Event Handlers
    //----------------------------------------------------------------------
    // expand / collapse all schedules
    onShowExtendedSchdule: function onShowExtendedSchdule(event) {
        event.preventDefault();

        // go through all .schedule .day and run expandCollapseSchedule
        // on each .button if it isn't already expanded.
        // force collapse if clicked to collapse

        var collapseText = 'Collapse extended schedule';
        var expandText = 'Show extended schedule';

        $(this).toggleClass(InternationalProgram.classExpanded);
        if($(this).hasClass(InternationalProgram.classExpanded)) {
            // expand
            $('.section-schedule .day .button').each(function() {
                // check if already expanded, if so don't call
                if(!$(this).hasClass(InternationalProgram.classExpanded)) {
                    InternationalProgram.expandCollapseSchedule($(this));
                }
            });
            $(this).text(collapseText);
        } else {
            //collapse
            $('.section-schedule .day .button').each(function() {
                InternationalProgram.expandCollapseSchedule($(this), true);
            });
            $(this).text(expandText);
        }
    },

    // show or hide hidden events, change button text to reflect state
    onScheduleShowCollapse: function onScheduleShowCollapse(event) {
        event.preventDefault();

        InternationalProgram.expandCollapseSchedule($(this));
    },

    // smooth scroll anchor links
    onAnchorLinkClick: function onAnchorLinkClick(event) {
        event.preventDefault();

        var target = $(this.hash);

        $('html,body').animate({
            scrollTop: target.offset().top
        }, 1000);
    },

    onBackToTopClick: function onBackToTopClick(event) {
        event.preventDefault();

        $('html,body').animate({
            scrollTop: $('#section-meeting-content').offset().top
        }, 1000);
    },

    //----------------------------------------------------------------------
    // Display
    //----------------------------------------------------------------------
    expandCollapseSchedule: function expandCollapseSchedule($btn, forceCollapse) {
        var $this = $btn;
        var $hiddenItems = $this.parents('.day').find('.schedule-item.hidden');

        // always collapse all menus if $btnExtendedSchedule is collapsed
        if(!forceCollapse) {
            $this.toggleClass(InternationalProgram.classExpanded);
            $hiddenItems.toggleClass('show');
        } else {
            $this.removeClass(InternationalProgram.classExpanded);
            $hiddenItems.removeClass('show');
        }

        // update button text
        if($hiddenItems.hasClass('show')) {
            $this.text(InternationalProgram.btnExpandedText);
        } else {
            var cntText = InternationalProgram.btnCollapsedTextCnt.replace('*', $this.attr('data-num-events'));
            $this.text(InternationalProgram.btnCollapsedText + cntText);
        }
    }

};


var RequestCRMID = (function() {

    var init = function init() {

        _addListeners();
    }

    var _addListeners = function _addListeners() {

        $('#other-information-type').on('change', _onOtherTypeChange);
        $('.birthdate-input').on('change', _onBirthdateChange);
        $('#form-request-crm-id').on('submit', _onFormSubmit);
    }

    //----------------------------------------------------------------------
    // Form Event Handlers
    //----------------------------------------------------------------------
    var _onOtherTypeChange = function _onOtherTypeChange(event) {
        $('.other-information-field-block').hide();
        $('.other-information-field-block').find('.input').removeClass('required');

        $('[data-type="' + $(this).find(":selected").val() + '"]').find('.input').addClass('required');
        $('[data-type="' + $(this).find(":selected").val() + '"]').show();
    }

    var _onBirthdateChange = function _onBirthdateChange(event) {
        var year = $('#year').val();
        var month = $('#month').val();
        var day = $('#day').val();
        
        if(year.toString().length > 0 && month.toString().length > 0 && day.toString().length > 0) {
            // Ensure month and day are two digits
            month = month.toString().padStart(2, '0');
            day = day.toString().padStart(2, '0');
            
            // Format as YYYY/MM/DD
            var dateString = year + '/' + month + '/' + day;
            
            // Validate the date
            if (_isValidDate(dateString)) {
                $('#BirthDate').val(dateString);
                $('#birthdate-error').hide();
            } else {
                $('#BirthDate').val('');
                $('#birthdate-error').show().text('Please enter a valid date');
            }
        } else {
            $('#BirthDate').val('');
            $('#birthdate-error').hide();
        }
    }

    var _onFormSubmit = function _onFormSubmit(event) {
        event.preventDefault();

        var errors = [];
        $(this).find('.required').each( function(){

            var inputVal;

            try {
               $(this).val().length;
               inputVal = $(this).val();
            }
            catch(error) {
                inputVal = $(this).find('option:selected').val();
            }

            if( _validateInput($(this), inputVal) ) {
                // console.log('dude: ' + inputVal);
                // hide error
                $(this).siblings('.error').removeClass('visible');
                $(this).parent().siblings('.error').removeClass('visible');
            } else {
                // show error
                errors.push( $(this) );
                $(this).siblings('.error').addClass('visible');
                $(this).parent().siblings('.error').addClass('visible');
            }
        });

        if(errors.length > 0) {
            return false;
        }

        var $this           = $(this);
        var formData        = {};

        $.each($('.required', this).serializeArray(),
            function(i, v) {
                formData[v.name] = v.value;
        });

        var ajaxData = {
            action    : 'put_crm_search_contact_id',
            crm_nonce : localized_object.nonce,
            data      : formData
        };

        $.ajax({
            type       : "POST",
            url        : localized_object.ajax_url,
            data       : ajaxData,
            dataType   : "json",
            timeout    : 20000,
            beforeSend : function() {
                $this.find('input:not(:disabled), select:not(:disabled), textarea:not(:disabled)').prop('disabled', true);
                $this.find('input, select, label').css({'cursor': 'progress'});
                $this.css({'cursor': 'progress'});
                }
            })
            .done( function( response ) {
                console.log('Server response:', response); // Debug log
                
                // Show "no results" for empty/invalid responses or when data is false
                if (!response || !response.data || response.data === false) {
                    var $results = $('#results-not-found');
                    $results.find('.message').text(response && response.error ? response.error : 'No matching records found');
                    
                    // Animation setup
                    $results.addClass('animate-in');
                    $results.removeClass('hidden');

                    // Animation run
                    setTimeout(function(){
                        var height = $results.outerHeight();
                        $results.css({'height': 0});
                        $results.removeClass('animate-in');
                        $results.animate({
                            'height': height,
                            'opacity': 1
                        }, 300);
                    }, 1);
                    return;
                }

                // Only proceed if we have a valid CRM ID string
                if(response.data && typeof response.data === 'string' && response.data.length > 0) {
                    var $results = $('#results');
                    var $form = $('.register-form-container');
                    var href = $results.find('a').attr('href');
                    var crmID = response.data;

                    $results.find('.crm-id').text(crmID);
                    $results.find('a').attr('href', href + '?alumni_id=' + crmID);

                    // Animation setup
                    $results.addClass('animate-in');
                    $results.css({'width': $form.outerWidth()});
                    $results.removeClass('hidden');
                    $($results.parent()).css({'min-height': $results.outerHeight()});

                    // Animation run
                    $('#results-not-found').animate({
                        'height': 0,
                        'opacity': 0
                    }, 500, function(){
                        $(this).remove();
                    });

                    $('.register-form-container').animate({
                        'height': 0,
                        'opacity': 0
                    }, 500, function(){
                        $(this).remove();
                    });

                    $results.animate({
                        'opacity': 1,
                    }, 500, function(){
                        $results.removeClass('animate-in');
                    });

                } else {
                    var $results = $('#results-not-found');
                    var errorMessage = response.error || 'No matching records found';
                    
                    
                    // Update error message text
                    $results.find('.message').text(errorMessage);

                    // Animation setup
                    $results.addClass('animate-in');
                    $results.removeClass('hidden');

                    // Animation run
                    setTimeout(function(){
                        var height = $results.outerHeight();
                        $results.css({'height': 0});
                        $results.removeClass('animate-in');
                        $results.animate({
                            'height': height,
                            'opacity': 1
                        }, 300);
                    }, 1);
                }
            })
            .fail( function( request, status, err ) {
                console.log( 'ERR => ' );
                console.log( err );
                console.log(request);
                console.log(status);
                
                var $results = $('#results-not-found');
                var errorMessage = 'No matching records found';
                
                // Only show error message if it's not a 200 status with empty response
                if (request.status !== 200) {
                    errorMessage = 'An error occurred while processing your request. Please try again.';
                    
                    // If we have a more specific error message from the server
                    if (request.responseJSON && request.responseJSON.error) {
                        errorMessage = request.responseJSON.error;
                    }
                }
                
                console.log('Error message:', errorMessage); // Debug log
                
                $results.find('.message').text(errorMessage);
                
                // Animation setup
                $results.addClass('animate-in');
                $results.removeClass('hidden');

                // Animation run
                setTimeout(function(){
                    var height = $results.outerHeight();
                    $results.css({'height': 0});
                    $results.removeClass('animate-in');
                    $results.animate({
                        'height': height,
                        'opacity': 1
                    }, 300);
                }, 1);
            }).always(function() {
                // Re-enable form
                $this.find('input:not(:disabled), select:not(:disabled), textarea:not(:disabled)').prop('disabled', false);
                $this.find('input, select, label').css({'cursor': 'auto'});
                $this.find('input[type="submit"]').css({'cursor': 'pointer'});
                $this.css({'cursor': 'auto'});
                
                // Ensure loading state is removed
                $this.removeClass('loading');
            });
    }

    //----------------------------------------------------------------------
    // Utility
    //----------------------------------------------------------------------
    var _validateInput = function _validateInput($el, inputVal) {

        var validator = ($el.attr('data-validate-type')) ? $el.attr('data-validate-type') : $el.attr('type');

        switch(validator) {
            case 'text':
                return inputVal.length > 0;
                break;
            case 'date':
                return _isValidDate(inputVal);
                break;
            case 'number':
                // check for maxlength and use if exists
                if( $el.attr('maxlength') ) {
                    if(inputVal.length != $el.attr('maxlength') ) {
                        return false;
                    }
                }

                return !isNaN(parseFloat(inputVal)) && isFinite(inputVal);
                break;
        }
    }

    // http://stackoverflow.com/a/6178341
    // validates date string based on format mm/dd/yyyy
    var _isValidDate = function _isValidDate(dateString) {

        // if(!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString))
        // if(!/^
        //     \d{1,2}\/ month
        //     \d{1,2}\/ day
        //     \d{4}$/ year
        //     .test(dateString))

        if(!/^\d{4}\/\d{1,2}\/\d{1,2}$/  .test(dateString))
            return false;

        var parts = dateString.split("/");
        // var day = parseInt(parts[1], 10);
        // var month = parseInt(parts[0], 10);
        // var year = parseInt(parts[2], 10);
        var year = parseInt(parts[0], 10);
        var month = parseInt(parts[1], 10);
        var day = parseInt(parts[2], 10);

        if(year < 1000 || year > 3000 || month == 0 || month > 12)
            return false;

        var monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];

        // Adjust for leap years
        if(year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
            monthLength[1] = 29;

        return day > 0 && day <= monthLength[month - 1];
    }


    //----------------------------------------------------------------------
    // Expose
    //----------------------------------------------------------------------
    return {
        init: init
    }

})();

var MenteeConnect = (function() {

    var newRedirect    = '/connect/';
    var resultsPageCurrent = 1;
    var resultsPageTotal = 1;

    var init = function init() {

      if ( $('.autocomplete').length > 0 ) {

        $('.autocomplete').autocomplete({
            source: window.specialities,
            change: function (event, ui) {
                var element = event.currentTarget.id;

                if (ui.item == null || ui.item == undefined) {
                    var txtSearchProNum = $( "#" + element );
                    txtSearchProNum.val("");
                }
            }
        });

      }

        var queryStringLocation  = _getUrlParams('location');
        var queryStringSpecialty = _getUrlParams('specialty');

        // if ( queryStringLocation || queryStringSpecialty ) {
        //   _onSearchFormSubmit();
        // }
        if ( queryStringLocation || queryStringSpecialty ) {

          if(queryStringLocation) {
            setTimeout(function(){
              $('input[data-select="select-mentor-search-current-state"]').prop('checked', true);
              $('input[type="radio"][name="search-type"]').trigger('change');
              $('#mentor-search-current-state').val(queryStringLocation);
              _onSearchFormChange();

            }, 10);

            setTimeout(function(){
              $('form[data-type="state"]').trigger('submit');

            }, 20);
          }

          if(queryStringSpecialty) {
            setTimeout(function(){
              $('input[data-select="select-mentor-search-specialty"]').prop('checked', true);
              $('input[type="radio"][name="search-type"]').trigger('change');
              $('#mentor-search-specialty').val(queryStringSpecialty);
              _onSearchFormChange();

            }, 10);

            setTimeout(function(){
              $('form[data-type="specialty"]').trigger('submit');

            }, 20);
          }

        }

        _addListeners();

        $('input[data-select="select-mentor-search-current-state"]').prop('checked', true);
        $('input[data-select="select-mentor-search-current-state"]').trigger('change');

    }

    var _getUrlParams = function(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    var _addListeners = function _addListeners() {


        $('input[type="radio"][name="search-type"]').on('change', _onSearchFormSelection);
        $('input[type="radio"][name="search-type"]').on('change', _onSearchFormChange);


        $('.connect--search-form').on('submit', _onSearchFormSubmit);
        $('.connect--results').on('submit', '.connect--message-form', _messageMentorSubmit);
        $('.connect--results').on('keyup', '.connect--message', _messageMentorCount);
        $('.mentor-profile').on('change', _onSearchFormChange);


        $('.connect--mentorship-suggestion-form').on('submit', _onSuggestionFormSubmit);
        $('#mentoship-suggestion-textarea').on('keyup', _onSuggestionChange);

        $('.connect--results').on('click', '.connect--search-btn-pagination', function(event) {
          resultsPageCurrent = Number($(this).attr('data-next-page'));

          $('.select-mentor-search.active').closest('.connect--search-form').trigger('submit');
        });

        $('.connect--results').on('click', '.cancel-message-mentor', function(e) {

          e.preventDefault();
          var messageFormParent = $(this).parent().parent().parent().parent().parent().parent().parent();
          messageFormParent.toggleClass('show-connect--message-form');
          $(this).closest('form').find('textarea').val('');

          $('html,body').animate({
            scrollTop: messageFormParent.offset().top
          }, 'slow');

        });

        $('.navbar-connect-login').on('click', function(e) {
          e.preventDefault();
          $('body').addClass('show-connect--login-form');
        });

        $('.connect--login-form-close').on('click', function(e) {
          e.preventDefault();
          $('body').removeClass('show-connect--login-form');
        });

        $('.connect--results').on('click', '.connect--results-alumni-details-message', function(e) {

          e.preventDefault();

          var pageEl = $('body');

          if ( pageEl.hasClass('logged-in') ) {

            $('.connect--message-results h4').remove();
            var messageFormParent = $(this).parent().parent().parent();
            var messageForm       = messageFormParent.find('.connect--message');

            messageFormParent.toggleClass('show-connect--message-form');

            $('html,body').animate({
              scrollTop: messageForm.offset().top
            }, 'slow' );

          } else {

            pageEl.toggleClass('show-connect--login-form');

          }

        });




        $('.connect').on('click', '.connect--results-alumni-content-residency-filter ul li a', function(event) {
          event.preventDefault();
          var filter_by = $(event.target).attr('data-filter-option');
          // console.debug('filter by',filter_by);
          $('.connect--search-form input[name="filter_by"]').val(filter_by);

          // submit search form
          var $form = $('.select-mentor-search.active').closest('.connect--search-form');

          $form.trigger('submit');

        });

    }

    var _messageMentorCount = function() {


      var charLength = $(this).val().length;
      $(this).next().find('span').text( ( 250 - charLength ) );

    }

    var _messageMentorSubmit = function(event) {

      event.preventDefault();

      var thisForm = $(this);
      var formData = thisForm.serializeObject();
      var ajaxData = {
        action    : formData.action,
        data      : formData
      };

      $.ajax({
        type       : "POST",
        url        : localized_object.ajax_url,
        data       : ajaxData,
        dataType   : "json",
        timeout    : 20000,
        beforeSend : function() {
          thisForm.find('textarea').prop('disabled', 'disabled');
          thisForm.find('.cancel-message-mentor').prop('disabled', 'disabled');
          thisForm.find('.submit-message-mentor').prop('disabled', 'disabled');
        }
      })
      .done( function( response ) {

        var parentEl = thisForm.parent().parent().parent();

        if ( typeof response.status !== undefined ) {

          parentEl.find('.connect--message-results').html(response.results);

          if ( response.status == 'success' ) {

            parentEl.removeClass('show-connect--message-form');
            thisForm.find('textarea').val('');

            $('html,body').animate({
              scrollTop: parentEl.offset().top
            }, 'slow' );

          }

        } else {

          parentEl.find('.connect--message-results').html('<h4 class="error">Something went wrong sending message. Try again later.</h4>');

        }

      })
      .fail( function( request, status, err ) {

        console.log( 'REQUEST => ' + request );
        console.log( 'STATUS => ' + status );
        console.log( 'ERR => ' );
        console.log( err );

      }).always(function() {
        thisForm.find('textarea').removeProp('disabled');
        thisForm.find('.cancel-message-mentor').removeProp('disabled');
        thisForm.find('.submit-message-mentor').removeProp('disabled');
      });
    }

    //----------------------------------------------------------------------
    // Form Validation
    //----------------------------------------------------------------------
    var _formValidation = function(formData) {

      var validated   = false;
      var messaging   = '<p>Select either specialty or location</p>';
      var specialty   = formData.specialty;
      var location    = formData.location;
      var messagingEl = $('.connect--search-messaging');

      if ( specialty || location ) {
        validated = true;
      }

      if ( validated ) {
        messagingEl.html('');
      } else {
        messagingEl.html(messaging);
      }

      return validated;

    }

    //----------------------------------------------------------------------
    // Form Event Handlers
    //----------------------------------------------------------------------

    var _onSearchFormSelection = function _onSearchFormSelection(event) {

        event.preventDefault();

        $('.select-mentor-search').removeClass('active');
        $('.' + $(this).attr('data-select')).addClass('active');

        $('.connect--search-form-selection').find('label').removeClass('active');
        $(this).parent().addClass('active');
    }


    var _onSearchFormChange = function _onSearchFormChange(event) {

        var val = $('.select-mentor-search.active').find('.mentor-profile').val();

        if(val.length > 0) {

            $('.connect--search-form').find('.button').attr('disabled', false);
        } else {
            $('.connect--search-form').find('.button').attr('disabled', true);
        }

        if( $('.select-mentor-search.active').hasClass('select-mentor-search-current-state') ) {
          $('.connect--results-alumni-content-residency-filter').show();
        } else {
          $('.connect--results-alumni-content-residency-filter').hide();
        }
    }


    var _onSearchFormSubmit = function(event) {

        var thisForm;
        var formData;

        event.stopImmediatePropagation();

        if ( typeof event !== undefined && event ) {

          event.preventDefault();
          thisForm = $(this);
          formData = thisForm.serializeObject();
        }

        if ( !_formValidation( formData ) ) { return };

        // Hide banner
        $('.connect--banner').animate({'opacity': 0, 'height': 0}, function(event){
            $(this).remove();
        });

        var redirect   = $('#login-form').find("input[name='redirect_to']");
        newRedirect    = '/connect/';
        var newQueryString = '';

        if ( formData.location ) {
          newQueryString += '?location=' + formData.location;
        }

        if ( formData.specialty ) {
          newQueryString += newQueryString ? '&specialty=' + formData.specialty : '?specialty=' + formData.specialty;
        }

        newRedirect += encodeURI( newQueryString );
        redirect.val( newRedirect );

        formData.paged = resultsPageCurrent;

        var action = 'search_mentorship';
        if(formData.filter_by && formData.filter_by != 'all') {
          action = action + '_' + formData.filter_by;
        }

        var ajaxData = {
            action   : action,
            // action   : 'search_mentorship_residency_location',
            // action   : 'search_mentorship_current_location',
            // action   : 'search_mentorship',
            wp_nonce : localized_object.nonce,
            data     : formData
        };

        $.ajax({
          type       : "POST",
          url        : localized_object.ajax_url,
          data       : ajaxData,
          dataType   : "json",
          timeout    : 20000,
          beforeSend : function() {
            $('.connect--results').removeClass('show-results');
          }
        })
        .done( function( response ) {

          $('.connect--results').empty();

          if ( typeof response.status !== undefined ) {

            if ( response.status == 'success' ) {

            var searchedSpeciality  = formData.specialty ? '"' + formData.specialty + '"' : '';
            var searchedLocation    = formData.location ? '"' + formData.location + '"' : '';

              if(searchedLocation.length == 2) {
                  searchedLocation = northAmericanStates[searchedLocation];
              }

              _updateResults( response, {'searched_location': searchedLocation, 'searched_speciality': searchedSpeciality} );

            } else {

              var query = formData.specialty ? '<strong>' + formData.specialty + '</strong>' : '';
              query += query ? ' and <strong>' + formData.location + '</strong>' : '<strong>' + formData.location + '</strong>';

              $('.connect--results-count').html( '<h4>0 results match your search</h4>' );
              // Don't shoe empty container if no results
              $('.connect--results ').append( response.results );
            }

            $('html,body').animate({
              scrollTop: $('.connect--results-count').offset().top
            }, 'slow', function() {
              $('.connect--results').addClass('show-results');
            });

          }

        })
        .fail( function( request, status, err ) {

          console.log( 'REQUEST => ' + request );
          console.log( 'STATUS => ' + status );
          console.log( 'ERR => ' );
          console.log( err );
          console.log('');

        }).always(function() {
          // $('.privacy-radio-input').prop("disabled", false);
        });

    };

    var _onSuggestionChange = function _onSuggestionChange(event){

        if($(this).val().length > 0) {
            $(this).parent().parent().find('.button').attr('disabled', false);
        } else {
            $(this).parent().parent().find('.button').attr('disabled', true);
        }

    }

    var _onSuggestionFormSubmit = function _onSuggestionFormSubmit(event) {
        event.preventDefault();

        var thisForm = $(this);
        var formData = thisForm.serializeObject();
        var ajaxData = {
            action   : 'submit_mentorship_suggestion',
            wp_nonce : localized_object.nonce,
            data     : formData
        };

        $.ajax({
          type       : "POST",
          url        : localized_object.ajax_url,
          data       : ajaxData,
          dataType   : "json",
          timeout    : 20000,
          beforeSend : function() {

          }
        })
        .done( function( response ) {

            if (response.status === 'success') {
                $('.connect--mentorship-suggestion').html(response.results);
            } else {
                $('.connect--mentorship-suggestion').html('<h4 class="error">Something went wrong sending your message. Please Try again later.</h4>');
            }

        })
        .fail( function( request, status, err ) {

          console.log( 'REQUEST => ' + request );
          console.log( 'STATUS => ' + status );
          console.log( 'ERR => ' );
          console.log( err );

        }).always(function() {

        });
    }


    //----------------------------------------------------------------------
    // UI
    //----------------------------------------------------------------------
    var _updateResults = function _updateResults( response, search ) {

      var results = response.results;
      var resultsEl    = $('.connect--results');
      var resultsCount = $('.connect--results-count');
      var searchType = $('.connect--search-form-selection').find('label.active input').attr('value');

      resultsEl.empty();
      resultsCount.empty();

      // var resultsText = (results.length > 1) ? 'results match' : 'result matches';
      // resultsCount.html( '<h4>' + response.totalResults + ' ' + resultsText + ' your search for ' + search.searched_speciality + '' + search.searched_location + '</h4>' );
      var resultsText = 'Results';
      resultsCount.html( '<h4>' + resultsText + ' for your search of ' + search.searched_speciality + '' + search.searched_location + '</h4>' );

      var filter_link_options = {
        some_variable: 'example'
      };
      var filter_links = _injectProperties( $('#alumni-residency-template-filtering-options').html(), filter_link_options );

      resultsCount.append(filter_links);

      // // moved to addListeners
      // $('.connect--results-alumni-content-residency-filter ul li a').on('click', function(event) {
      //   event.preventDefault();
      //   var filter_by = $(event.target).attr('data-filter-option');
      //   console.debug('filter by',filter_by);
      //   $('.connect--search-form input[name="filter_by"]').val(filter_by);
      //
      //   $('.connect--search-form').trigger('submit');
      // });


      if ( results.length > 0 ) {

        for ( i = 0; i < results.length; i++ ) {

          var residencies        = results[i].residencies;
          var residencies_result = '';

          for ( r = 0; r < residencies.length; r++ ) {
            residencies_result += _injectProperties( $('#alumni-residency-template').html(), residencies[r] );
          }

          results[i]['residencies'] = residencies_result;

          if(_getKeyByValue( results[i]['current_state'], northAmericanStates )) {
              results[i]['current_state'] = _getKeyByValue( results[i]['current_state'], northAmericanStates );
          }

          var result   = _injectProperties( $('#alumni-template').html(), results[i] );
          var $listing = resultsEl.append(result).find('.result-listing');

        }

      }

      var currentPage = Number(response.currentPage);
      var totalPages = Number(response.totalPages);

      if(totalPages > 1) {

        if(currentPage > 1) {
          var nextpage = currentPage - 1;
          var btn = '<button style="float:left" class="connect--search-btn-pagination connect--search-btn-pagination-previous button button-blue button-account" data-next-page="' + nextpage + '">previous results</button>';
          resultsEl.append(btn);
        }

        if(currentPage < totalPages) {
          var nextpage = currentPage + 1;
          var btn = '<button style="float: right;" class="connect--search-btn-pagination connect--search-btn-pagination-next button button-blue button-account" data-next-page="' + nextpage + '">more results</button>';
          resultsEl.append(btn);
        }

        var status = '<div style="margin: 0 auto; text-align: center; padding-top: 10px">page ' + currentPage + ' of ' + totalPages + '</div>';
        resultsEl.append(status);

      }

    }

    //----------------------------------------------------------------------
    // Util
    //----------------------------------------------------------------------
    var _injectProperties = function _injectProperties(templateHTML, context) {

        var _markup = templateHTML;

        for (var property in context) {
            var propertyString = '{' + property + '}';
            var targetProperty = context[property];

            if (_markup.search(propertyString) != -1) {
                _markup = _markup.replace(new RegExp(propertyString, 'gi'), targetProperty);
            }
        }

        // Remove Unused Tokens
        _markup = _markup.replace(/\{([^}]+)\}/g, "");

        return _markup;

    }

    var _getKeyByValue = function _getKeyByValue(val, obj) {
        for( var prop in obj ) {
            if( obj.hasOwnProperty( prop ) ) {
                if( obj[ prop ] === val )
                return prop;
            }
        }
    }


    //----------------------------------------------------------------------
    // Expose
    //----------------------------------------------------------------------
    return {
        init: init
    }

})();




var FeaturedProfile = (function() {

    var init = function init() {

      _addListeners();
    }

    var _addListeners = function _addListeners() {

      $('#featured-profile-enrollment-form').on('submit', _onFeaturedFormSubmit);
      $('#mayo_alumni_featured_profile_why').on('keydown', _characterCount);
    }

    //----------------------------------------------------------------------
    // Form Event Handlers
    //----------------------------------------------------------------------
    var _onFeaturedFormSubmit = function _onFeaturedFormSubmit(event) {
      event.preventDefault();

      var thisForm = $(this);
      var formData = thisForm.serializeObject();

      formData.addresses = [];
      $('.user-info .my-profile-list-item').each(function() {

        formData.addresses.push($(this).text());
      });

      // add name, email and address to data
      formData.name = $('.user-info .name').text();
      formData.email = $('.user-info .email').text();

      var ajaxData = {
        action    : 'featured_profile_submission',
        data      : formData
      };

      // Validation
      var validForm = true;

      if($('#mayo_alumni_featured_profile_why').val().length < 1) {
        $('#mayo_alumni_featured_profile_why').prev().addClass('active');

        validForm = false;
      }

      if($('.primary-phone-number').find('.error')) {
        $('.primary-phone-number').find('.error').addClass('active');
      }

      $('.address-required').each(function(index) {
        if($(this).val().length < 1) {
          $(this).prev('label').addClass('error');
          validForm = false;
        } else {
          $(this).prev('label').removeClass('error');
        }
      });

      if(!validForm) return false;

      $('#mayo_alumni_featured_profile_why').prev().removeClass('active');
      $('.primary-phone-number').find('.error').removeClass('active');
      $('.business-address').find('.error').removeClass('active');


      // Add non-form data to ajaxData
      ajaxData.data.primary_phone = $('.required-phone').text();

      // Add address (if applicable) to form data
      if($('.profile-form-address').serializeObject()) {

        // var addAddress = $('.profile-form-address').serializeArray()
        // for(var i=0; i<addAddress.length; i++) {
        //   ajaxData.data[addAddress[i].name] = addAddress[i].value;
        // }

        var address = $('.profile-form-address').serializeObject();

        ajaxData.crm_nonce = address.crm_nonce;

        delete address.crm_nonce;
        delete address._wp_http_referer;

        ajaxData.data.add_address = address;

      }

      $.ajax({
        type       : "POST",
        url        : localized_object.ajax_url,
        data       : ajaxData,
        dataType   : "json",
        timeout    : 20000,
        beforeSend : function() {
          thisForm.find('.button').prop('disabled', 'disabled');

          // Check for name and email
          if( $('.user-info').find('.name').text().length < 1 ||
              $('.user-info').find('.email').text().length < 1 ) {
                return false;
          }
        }
      })
      .done( function( response ) {

        // $('.submission-results').find('.title').text(response.result.title);
        // $('.submission-results').find('.message').text(response.result.message);

        $('.submission-results').find('.title').text('Success!');
        $('.submission-results').find('.message').text('We\'ll be in touch.');

      })
      .fail( function( request, status, err ) {
        console.log( 'REQUEST => ' + request );
        console.log( 'STATUS => ' + status );
        console.log( 'ERR => ' );
        console.log( err );
      }).always(function(response, data, three, four) {
        $('.signup').slideUp();
        $('.submission-results').addClass('active');
      });
    }

    //----------------------------------------------------------------------
    // Utility
    //----------------------------------------------------------------------
    var _characterCount = function() {

      var charLength = $(this).val().length;
      $(this).next().find('span').text( ( $(this).attr('maxlength')- charLength ) );

    }



    //----------------------------------------------------------------------
    // Expose
    //----------------------------------------------------------------------
    return {
        init: init
    }

})();


var ExclusiveSwag = (function() {

    // Selectors
    $productImgContainer    = $('#product-img-container');
    $imgLoader              = $('#product-img-container .loader');
    $selectStyle            = $('#select-style');
    $shirtDetails           = $('.shirt-details');
    $selectShirt            = $('input[type=radio][name=ShirtType]');
    $selectDues             = $('input[type=radio][name=PayDues]');
    $totalPrice             = $('.total-price');
    $selectSize             = $('#select-size');
    $additionalDonation     = $('#additional-donation');
    $swagForm               = $('.swag-form');
    $btnAddToCart           = $('#btn-add-to-cart');

    var _productImages = [$productImgContainer.find('img')];
    var _cartQueue = [];


    var init = function init() {
      _addListeners();
    }

    var _addListeners = function _addListeners() {
      $selectStyle.on('change', _onStyleChange);
      $selectShirt.on('change', _onShirtChange);
      $totalPrice.on('change', _onTotalPriceChange);
      $additionalDonation.on('keyup', _onTotalPriceChange);
      $additionalDonation.on('keyup', _validate);

      $swagForm.on('submit', _onSwagFormSubmit);

      $('select').on('change', _validate);
      $('input').on('change', _validate);
    }

    //----------------------------------------------------------------------
    // Form Event Handlers
    //----------------------------------------------------------------------
    var _onStyleChange = function _onStyleChange(event) {

      if($selectStyle.val().length > 1) {
        $selectShirt.prop('disabled', false);
        $selectSize.prop('disabled', false);

        if($selectShirt.filter(':checked').length > 0) {
          $selectShirt.filter(':checked').trigger('change');
        }

        $shirtDetails.addClass('active');

      } else {
        $selectShirt.prop('disabled', true);
        $selectSize.prop('disabled', true);
        $shirtDetails.removeClass('active');
      }

    }

    var _onShirtChange = function _onShirtChange(event) {

      var style = $selectStyle.val();
      var $shirt = $selectShirt.filter(':checked');

      _swapImage($shirt.attr('data-image-' + style));
    }

    var _onTotalPriceChange = function _onTotalPriceChange(event) {

      var shirt = ($selectShirt.filter(':checked').length>0) ? Number($selectShirt.filter(':checked').attr('data-price')) : 0;
      var donation = Number($additionalDonation.val());
      var dues = ($selectDues.filter(':checked').length>0) ? Number($selectDues.filter(':checked').attr('data-price')) : 0;
      var sum = shirt + donation + dues;

      $('#swag-total-text').text('$' + sum);

      if(sum > 0) {
        $('#swag-total').addClass('active');
      } else {
        $('#swag-total').removeClass('active');
      }
    }

    var _onSwagFormSubmit = function _onSwagFormSubmit(event) {
      event.preventDefault();

      _cartQueue = [];
      _validate(true);

      if(_cartQueue.length > 0) {
        _processCartQueue();
      }
    }

    //----------------------------------------------------------------------
    // Validation
    //----------------------------------------------------------------------
    var _validateSwag = function _validateSwag(showErrors) {

      var valid = false;

      // Has a style been selected? - if so validate two other fields. If not okay.
      if($selectStyle.val()) {
        // apparel and size has been selected
        if($selectShirt.filter(':checked').attr('data-product-type') && $selectSize.val()) {
          valid = true;
        }
      } else {
        valid = true;
      }

      if(showErrors){
        if(valid) {
          $('#error-shirt').addClass('hidden');
        } else {
          $('#error-shirt').removeClass('hidden');

          var $container = $('html, body');
          var $error = $('#error-shirt');
          $container.animate({
            scrollTop: $error.offset().top - $container.offset().top + $container.scrollTop()
          }, 250);
        }
      }

      return valid;
    }


    var _validateDues = function _validateDues(showErrors) {

      var valid = false;

      // If dues are on page
      if($selectDues.length > 0) {

        if( $selectDues.filter(':checked').length > 0 ) {
          valid = true;
        }

        if(showErrors) {
          if(valid) {
            $('#error-dues').addClass('hidden');
          } else {
            $('#error-dues').removeClass('hidden');

            var $container = $('html, body');
            var $error = $('#error-dues');
            $container.animate({
              scrollTop: $error.offset().top - $container.offset().top + $container.scrollTop()
            }, 250);
          }
        }

      } else {
        valid = true;
      }

      return valid;
    }

    var _validate = function _validate(errors) {
      showErrors = (errors == true) ? true : false;
      _cartQueue = [];

      var valid = false;

      // Dues are visible - must pay dues to buy shirt
      if( $selectDues.length > 0 ) {
        // Need to have dues selected and shirt
        if( _validateDues(showErrors) && _validateSwag(showErrors) ) {
          valid = true;
          _processShirt();
          _processDues();
        }
      }

      // No Dues
      if( !($selectDues.length > 0) ) {
        if( _validateSwag(showErrors) ) {
          valid = true;
          _processShirt();
        }
      }

      // If adding an addiational donation - make sure other fields are kosher
      if($additionalDonation.val().length > 0) {
        if(_validateDues() && _validateSwag()) {
          valid = true;
          _processDonation();
        }
      }

      if(valid && $('#swag-total').hasClass('active')) {
        $btnAddToCart.prop('disabled', false);
      } else {
        $btnAddToCart.prop('disabled', true);
      }

      return valid;
    }



    //----------------------------------------------------------------------
    // Cart Methods
    //----------------------------------------------------------------------
    var _processShirt = function _processShirt() {
      if($selectShirt.filter(':checked').length > 0) {
        var variationID = $selectShirt.filter(':checked').attr('data-product-id-' + $selectStyle.val());
        var attributeType = encodeURIComponent( $selectShirt.filter(':checked').attr('data-product-type') );
        var attributeStyle = encodeURIComponent($selectStyle.val());
        var attributeSize = encodeURIComponent($selectSize.val());
        var shirt = '?add-to-cart=' + $selectStyle.attr('data-product-id') + '&variation_id=' + variationID + '$quantity=1&attribute_type=' + attributeType + '&attribute_style=' + attributeStyle + '&attribute_size=' + attributeSize;
        _cartQueue.push(shirt);
      }
    }

    var _processDues = function _processDues() {
      var dues = '?add-to-cart=' + Number($selectDues.filter(':checked').attr('data-id')) + '&variation_id=' + Number($selectDues.filter(':checked').attr('data-variation-id')) + '$quantity=1&attribute_type=' + $selectDues.filter(':checked').attr('value');
      _cartQueue.push(dues);
    }

    var _processDonation = function _processDonation() {
      var donation = '?add-to-cart=' + Number($additionalDonation.attr('data-product-id')) + '&nyp=' + Number($additionalDonation.val());
      _cartQueue.push(donation);
    }

    var _processCartQueue = function _processCartQueue() {

      $.ajax({
        type       : "POST",
        url        : _cartQueue[0],
        timeout    : 20000,
        beforeSend : function() {
          $btnAddToCart.prop('disabled', true);
          $btnAddToCart.addClass('loading');
          $btnAddToCart.text('');
        }
      })
      .done( function( response ) {
        _cartQueue.splice(0, 1);

        if(_cartQueue.length > 0) {
          _processCartQueue();
        } else {

          window.location.href = '/cart';
        }

      })
      .fail( function( request, status, err ) {

        $btnAddToCart.prop('disabled', false);
        $btnAddToCart.removeClass('loading');
        $btnAddToCart.text($btnAddToCart.attr('data-value'));
      }).always(function(response, data) {

      });
    }

    //----------------------------------------------------------------------
    // Display Methods
    //----------------------------------------------------------------------
    var _swapImage = function _swapImage(image) {

      // show loader
      $imgLoader.addClass('loading');

      var id = Date.now();
      $productImgContainer.append('<img id="' + id + '" />');
      var $img = $('#' + id);

      _productImages.push($img);

      $img.on('load', function() {

        for(var i=0; i<_productImages.length; i++) {
          var $index = _productImages[i];
          if($index.attr('id') != id ) {
            $index.remove();
            _productImages.splice(i, 1);
          }
        }

        // hide loader
        $imgLoader.removeClass('loading');

      }).each(function() {
        if(this.complete) $(this).trigger('load');
      });

      $img.attr('src', image);
    }



    //----------------------------------------------------------------------
    // Utility
    //----------------------------------------------------------------------


    //----------------------------------------------------------------------
    // Expose
    //----------------------------------------------------------------------
    return {
        init: init
    }

})();



var MyDues = (function() {


  $duesYearly = $('#dues-yearly');
  $duesRenewing = $('#dues-renewing');


  var init = function init() {

    $('.dues-type').addClass('hidden');
    $($('.dues-type-btn:checked').attr('value')).addClass('hidden');

    $('.dues-type-btn:checked').closest('label').addClass('checked');
    $('#'+$('.dues-type-btn:checked').attr('value')).removeClass('hidden');


    _addListeners();
  }

  var _addListeners = function _addListeners() {

    $('.dues-type-btn').on('change', _onCheck);

  }

  //----------------------------------------------------------------------
  // Event Handlers
  //----------------------------------------------------------------------
  var _onCheck = function _onCheck(event) {

    $('.form-dues-type').find('label').removeClass('checked');
    $(this).closest('label').addClass('checked');

    $('.dues-type').addClass('hidden');
    $('#' + $(this).attr('value')).removeClass('hidden');

  }

  //----------------------------------------------------------------------
  // Validation
  //----------------------------------------------------------------------

  //----------------------------------------------------------------------
  // Cart Methods
  //----------------------------------------------------------------------

  //----------------------------------------------------------------------
  // Display Methods
  //----------------------------------------------------------------------

  //----------------------------------------------------------------------
  // Utility
  //----------------------------------------------------------------------

  //----------------------------------------------------------------------
  // Expose
  //----------------------------------------------------------------------
  return {
      init: init
  }

})();






$(function() {

    InternationalProgram.init();
    // Mentorship.init();

    if( $('body').hasClass('page-connect') ) {
        MenteeConnect.init();
    }

    if( $('body').hasClass('page-request-crm-id') ||
        $('body').hasClass('page-request-crm-id-fb')) {
        RequestCRMID.init();
    }

    if( $('body').hasClass('page-featured-profile') ) {
        FeaturedProfile.init();
    }

    if( $('body').hasClass('page-my-dues') ) {
        MyDues.init();
    }

    if( $('body').hasClass('page-mentorship') ) {
        Mentorship.init();
    }

    // Page is no longer active
    // if( $('body').hasClass('page-limited-time-apparel') ) {
    //     ExclusiveSwag.init();
    // }

});
